import { Collapse } from 'bootstrap';

function Accordion({ node }) {
	const collapseElementList = [...node.querySelectorAll('.collapse')];
	const collapseList = collapseElementList.map(collapseEl => {
		return new Collapse(collapseEl, {
			toggle: false,
		});
	});
	return () => {
		collapseList.forEach(item => {
			item.dispose();
		});
	};
}

export default Accordion;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
